import { css } from "lit";

export const styles = css`
  .container {
    display: grid;
    height: 100dvh;

    grid-template:
      " menu  header" auto
      " menu  main  " 1fr
      / 15rem 1fr;
  }

  .menu {
    grid-area: menu;
    background: var(--sds-color-background-default-secondary);
  }

  page-header {
    grid-area: header;
  }

  .main {
    overflow: hidden;
    grid-area: main;
  }

  @media (max-width: 768px) {
    .container {
      grid-template:
        " header" auto
        " main  " 1fr
        " menu  " 4.5rem
        / 1fr;
    }

    .container.hide-mobile-menu {
      grid-template:
        " header" auto
        " main  " 1fr
        / 1fr;
    }

    .container.hide-mobile-menu .menu {
      display: none;
    }

    .menu {
      height: 4.5rem;
      position: sticky;
      bottom: 0;
      z-index: 1;
    }
  }

  @media (max-height: 500px) and (orientation: landscape) {
    .container.hide-mobile-menu {
      grid-template:
        "header" auto
        "main" 1fr
        / 1fr;
    }

    .container.hide-mobile-menu .menu {
      display: none;
    }
  }
`;
